/**
 * Deterministic avatar helpers shared by every list that renders an
 * initials-circle (transactions, members, staff). Single source of truth —
 * previously copied per screen, which let the palettes drift.
 */

/** Deterministic avatar palette (colors taken from mockups-v2). */
const AVATAR_COLORS: string[] = [
  '#4B5563',
  '#fe3eaa',
  '#17855B',
  '#B96C1A',
  '#1E5DA8',
  '#6B7280',
  '#7C3AED',
  '#0E7490',
];

/** Pick a deterministic avatar background color from an identifier (email/name). */
export function avatarColor(identifier: string | undefined | null): string {
  if (!identifier) return AVATAR_COLORS[0];
  let hash = 0;
  for (let i = 0; i < identifier.length; i++) {
    hash = (hash * 31 + identifier.charCodeAt(i)) | 0;
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

/** Up to two initials from an email local part ("ana.anic@…" → "AA"). */
export function avatarInitialsFromEmail(
  email: string | undefined | null
): string {
  if (!email) return '?';
  const local = email.split('@')[0];
  const parts = local.split(/[._\-+]/).filter((p) => p.length > 0);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return local.substring(0, 2).toUpperCase();
}

/** Up to two initials from a display name ("Ana Anić" → "AA"). */
export function avatarInitialsFromName(
  name: string | undefined | null
): string {
  const trimmed = (name || '').trim();
  if (!trimmed) return '?';
  return trimmed
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w.charAt(0).toUpperCase())
    .join('');
}
